import { Color } from '@persona-id/design-tokens';
import styled, { css } from 'styled-components';

import IconDrag from 'images/icons/drag.svg';

// StyledIconDrag is an IconDrag which changes color as you hover over it
export const StyledIconDrag = styled(IconDrag)<{
  $active: boolean;
  $hover?: boolean;
  $shouldHide?: boolean;
  $horizontal?: boolean;
}>`
  display: ${({ $shouldHide = false }) => ($shouldHide ? 'none' : 'inline')};

  ${({ $horizontal = false }) =>
    $horizontal
      ? css`
          transform: rotate(90deg);
        `
      : ''}

  ${({ $active = false, $hover = false }) =>
    $active
      ? css`
          cursor: grabbing;
          opacity: 1;
        `
      : $hover
        ? css`
            cursor: grab;
            opacity: 1;
          `
        : css`
            cursor: normal;
            opacity: 0.4;
          `}

  transition: opacity 0.2s ease-in-out;

  path {
    stroke: ${Color.CoreSlate1000};
    stroke-width: 1px;
  }
`;
